export const termsPlaceholder = [
  {
    term: "El coche",
    definition: "Car",
    keywords: ["masculine", "couch"],
  },
  {
    term: "wahrscheinlich",
    definition: "probably",
    keywords: ["war", "shine", "lich"],
  },
  {
    term: "grêle",
    definition: "skinny",
    keywords: ["grill", "legs"],
  },
  {
    term: "La lata",
    definition: "A can",
    keywords: ["latvia", "late"],
  },
  {
    term: "gaspiller",
    definition: "to waste",
    keywords: ["gas", "spilling"],
  },
  {
    term: "Der Tisch",
    definition: "table",
    keywords: ["masculine", "dish", "tissue"],
  },
  {
    term: "cracher",
    definition: "to spit",
    keywords: ["crash"],
  },
];
